'use client';

import { useDirection } from '@repo/react-hooks';
import { Carousel, CarouselApi, CarouselContent, CarouselItem } from '@repo/ui/carousel';
import { cn } from '@repo/utils/cn';
import { StaticImageData } from 'next/image';
import { ReactNode, useEffect, useState } from 'react';
import Banner from '../banner';
import BannersIndicators from './banners-indicators';

// import SwipeButtons from './swipe-buttons';

export type BannerType = {
  title?: string | ReactNode;
  subTitle?: string | ReactNode;
  img?: string | StaticImageData;
  imageUrl?: string;
  redirectUrl?: string;
  target?: string;
  id?: string;
  imageHeight?: number;
  imageWidth?: number;
  buttonLabel?: string;
  titleClassName?: string;
  subTitleClassName?: string;
  imgClassName?: string;
};

type CarouselBannersProps = {
  banners: BannerType[];
  bannerButtonRenderer: (banner: BannerType) => ReactNode;
  carouselItemClassName?: string;
  bannerContentClassName?: string;
  bannerImageClassName?: string;
  carouseIndicatorClassName?: string;
  carouselLeftIndicatorClassName?: string;
  carouselRightIndicatorClassName?: string;
  bannerTitleClassName?: string;
  bannerSubTitleClassName?: string;
  scale?: boolean;
  autoplay?: boolean;
  align?: 'start' | 'center' | 'end';
};

const CarouselBanners = ({
  banners,
  carouselItemClassName,
  carouseIndicatorClassName,
  // carouselLeftIndicatorClassName,
  // carouselRightIndicatorClassName,
  bannerButtonRenderer,
  bannerContentClassName,
  bannerImageClassName,
  bannerTitleClassName,
  bannerSubTitleClassName,
  scale = false,
  autoplay = false,
  align = 'start',
}: CarouselBannersProps) => {
  const direction = useDirection();
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (!api) return;

    setCurrent(api.selectedScrollSnap());
    api.on('select', () => setCurrent(api.selectedScrollSnap()));
  }, [api]);

  return (
    <div className="relative">
      <Carousel
        autoplay={autoplay}
        setApi={setApi}
        className="w-full overflow-x-hidden"
        opts={{
          direction,
          loop: true,
          align,
        }}
      >
        {/* {banners.length > 1 && (
          <SwipeButtons
            side="LEFT"
            leftIndicatorClassName={carouselLeftIndicatorClassName}
          />
        )} */}
        <CarouselContent>
          {banners.map((banner, index) => (
            <CarouselItem
              key={banner.id}
              className={cn(carouselItemClassName, scale ? { 'z-10 brightness-100': current === index } : null)}
            >
              <Banner
                title={banner.title}
                subTitle={banner.subTitle}
                img={banner.imageUrl || banner.img}
                imageHeight={banner.imageHeight}
                imageWidth={banner.imageWidth}
                button={bannerButtonRenderer(banner)}
                contentClassName={bannerContentClassName}
                titleClassName={cn(bannerTitleClassName, banner.titleClassName)}
                subTitleClassName={cn(bannerSubTitleClassName, banner.subTitleClassName)}
                imageClassName={cn(bannerImageClassName, banner.imgClassName)}
                className={cn(
                  scale
                    ? { 'scale-x-[1.35] scale-y-[1.40] transition-transform duration-300': current === index }
                    : null
                )}
              />
            </CarouselItem>
          ))}
        </CarouselContent>
        {/* {banners.length > 1 && (
          <SwipeButtons
            side="RIGHT"
            rightIndicatorClassName={carouselRightIndicatorClassName}
          />
        )} */}
      </Carousel>
      <BannersIndicators
        api={api}
        selectedBannerIndex={current}
        bannersLength={banners.length}
        className={carouseIndicatorClassName}
      />
    </div>
  );
};

export default CarouselBanners;
